import Vue from 'vue'
import Vuex from 'vuex'
import moduleLearnEnglish from "./modules/learnenglish/moduleLearnEnglish";
import moduleMall from "./modules/mall/moduleMall";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isMobile: false,
    tarBarShow:true,
  },
  mutations: {
    aaa(state,payload){
      state.isMobile=true;
    },
    bbb(state,payload){
      state.tarBarShow=false;
    },
    ccc(state,payload){
      state.tarBarShow=true;
    }
  },
  actions: {

  },

  modules: {
    a:moduleLearnEnglish,
    b:moduleMall,
  }
})
